.row {
  display: flex;
  align-items: center;
  gap: var(--zumpo-space-12);
  min-height: 56px;
  padding: var(--zumpo-space-8) var(--zumpo-space-12);
  color: var(--zumpo-ink);
}

/* A long name gives way only once the detail has wrapped as far as it can. */
.name {
  overflow: hidden;
  min-width: 0;
  text-overflow: ellipsis;
  white-space: nowrap;
  font: var(--zumpo-text-label);
  letter-spacing: var(--zumpo-text-label-tracking);
}

/* On the desktop line the tag and detail sit in the row as if unwrapped. */
.outcome {
  display: contents;
}

.detail {
  flex-shrink: 1000;
  margin-left: auto;
  color: var(--zumpo-muted);
  font: var(--zumpo-text-small);
  letter-spacing: var(--zumpo-text-small-tracking);
  text-align: right;
}

.part {
  white-space: nowrap;
}

.points {
  flex: none;
  min-width: 56px;
  font: var(--zumpo-text-number);
  letter-spacing: var(--zumpo-text-number-tracking);
  text-align: right;
}

.mine .points {
  color: var(--zumpo-danger);
}

/* Phone: the results card is a third narrower, and the Phone layout (MO13,
   MO19) puts the name on a line of its own above the tag and detail, the
   avatar and points spanning both. */
@container (max-width: 560px) {
  .row {
    display: grid;
    grid-template-columns: auto minmax(0, 1fr) auto;
    column-gap: var(--zumpo-space-8);
    row-gap: var(--zumpo-space-4);
    align-items: center;
    padding: var(--zumpo-space-8) var(--zumpo-space-4);
  }

  .row > :first-child,
  .points {
    grid-row: 1 / 3;
  }

  .name {
    grid-row: 1;
    grid-column: 2;
  }

  .outcome {
    display: flex;
    flex-wrap: wrap;
    grid-row: 2;
    grid-column: 2;
    align-items: center;
    gap: var(--zumpo-space-8);
    min-width: 0;
  }

  .detail {
    margin-left: 0;
    text-align: left;
  }
}
